import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
  Popover,
} from "@mui/material";
import {
  getAllSubmittedRecords,
  deleteSubmittedRecord,
  useSubmittedRecordById,
  createParameterMaster,
} from "./mutation";
import { handleToastMsg } from "../../components/Toast";
import { useMutation, useQuery, useQueryClient } from "react-query";

import Paper from "@mui/material/Paper";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
// import DeleteIcon from "@mui/icons-material/Delete";
import { Link, useNavigate } from "react-router-dom";
import "./styles.css";
import DeleteConfirmationDialog from "../../components/DeleteConfirmationDialog";
import DialogForLoadingMachine from "../../components/DialogForLoadingMachine";
import CheckOverflow from "../../utils/CheckOverflow";
import CreateField from "../../components/CreateField";

function ParameterMasters() {
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const actionColumnWidth = isMdScreen ? "18vw" : isSmScreen ? "20vw" : "12vw";

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedIdToEdit, setSelectedIdToEdit] = useState("");
  const [selectedIdToDelete, setSelectedIdToDelete] = useState("");
  const [filterText, setFilterText] = useState("");
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const {
    data: submittedMasterData,
    isLoading: isSubmittedMasterDataLoading,
    isError: isSubmittedMasterDataError,
  } = useQuery("all-parameters", getAllSubmittedRecords, {
    staleTime: 0, // Data will be considered stale immediately
    refetchOnWindowFocus: true, // Refetch on window focus
    refetchOnMount: true, // Refetch on mount
  });

  const handleFilterChange = (event) => {
    setFilterText(event.target.value);
  };

  // eslint-disable-next-line no-unused-vars
  const handleOpenDeleteDialog = (id) => {
    setSelectedIdToDelete(id);
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const mutation = useMutation(deleteSubmittedRecord, {
    onSuccess: () => {
      queryClient.invalidateQueries("all-parameters");
      handleToastMsg("Deleted successfully", "success");
    },
    onError: (error) => {
      handleToastMsg(`Error: ${error.message}`, "error");
    },
  });

  const createMasterDataMutation = useMutation(createParameterMaster, {
    onSuccess: () => {
      queryClient.invalidateQueries("all-parameters"); // Refresh the parameter list after successful creation
      handleToastMsg("Created successfully", "success"); // Show success message
      setFormData({
        name: "",
        category: "",
        inputType: "",
      });
      setOpenCreateMasters(false); // Close the dialog after creation
    },
    onError: (error) => {
      if (error?.response?.data?.message) {
        handleToastMsg(`${error?.response?.data?.message}`, "error");
      } else {
        handleToastMsg(`Error: ${error?.message}`, "error"); // Show error message
      }
    },
  });

  const {
    data: submittedRecordById,
    isLoading: isSubmittedLoading,
    isError: isSubmittedError,
  } = useSubmittedRecordById(selectedIdToEdit);
  const handleEdit = (id) => {
    setSelectedIdToEdit(id);
  };

  useEffect(() => {
    if (
      selectedIdToEdit &&
      !isSubmittedLoading &&
      !isSubmittedError &&
      submittedRecordById
    ) {
      setShouldNavigate(true);
    }
  }, [
    selectedIdToEdit,
    isSubmittedLoading,
    isSubmittedError,
    submittedRecordById,
  ]);

  useEffect(() => {
    if (shouldNavigate) {
      // Extract only the serializable data needed
      const editData = {
        id: submittedRecordById.data.id,
        partyName: submittedRecordById.data.partyName,
        partyCode: submittedRecordById.data.partyCode,
        variety: submittedRecordById.data.variety,
        general: submittedRecordById.data.general,
        blowroom: submittedRecordById.data.blowroom,
        carding: submittedRecordById.data.carding,
        drawing: submittedRecordById.data.drawing,
        simplex: submittedRecordById.data.simplex,
        spinning: submittedRecordById.data.spinning,
        autoconer: submittedRecordById.data.autoconer,
        others: submittedRecordById.data.others,
      };

      navigate("/add-parameter-master", {
        state: { editData },
      });
      setShouldNavigate(false); // Reset navigation flag
    }
  }, [shouldNavigate, navigate, submittedRecordById]);

  const handleDeleteConfirmed = () => {
    // delete selectedIdToEdit
    mutation.mutate(selectedIdToDelete);
    handleCloseDeleteDialog();
  };

  //this is for pretend the rerender issue when we give checkoverflow params
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    setFilteredData(
      submittedMasterData?.data?.filter(
        (row) =>
          row?.partyName?.toLowerCase().includes(filterText.toLowerCase()) ||
          row?.partyCode?.toLowerCase().includes(filterText.toLowerCase())
      ) || []
    );
  }, [submittedMasterData, filterText]);

  const [openCreateMasters, setOpenCreateMasters] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    inputType: "",
    outOfNorms: "",
    options: [],
  });

  const [errors, setErrors] = useState({
    name: false,
    category: false,
    inputType: false,
    outOfNorms: false,
    options: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "",
    }));
  };

  console.log(formData);

  const handleCreate = () => {
    const { name, category, inputType, outOfNorms, options } = formData;

    //these two check for trimming the space starting and ending
    const trimmedName = name.trim();
    const trimmedoptions = options?.map((item) =>
      typeof item === "string" ? item.trim() : item
    );

    console.log({ trimmedName, trimmedoptions });

    // Validate each field and store the errors in an object
    const newErrors = {
      name: name.trim() === "",
      category: category.trim() === "",
      inputType: inputType.trim() === "",
      outOfNorms: outOfNorms.trim() === "",
      options:
        (inputType === "Single select" || inputType === "Multiple select") &&
        options.length === 0,
    };
    // console.log("newErrors",newErrors)
    // Update the error state
    setErrors(newErrors);

    // Check if any field has an error
    const hasErrors = Object.values(newErrors).some((error) => error);

    // If there are no errors, proceed with the API call
    if (!hasErrors) {
      const payload = {
        name: trimmedName,
        category: category.toLowerCase(),
        inputType,
        outOfNorms,
        options: trimmedoptions,
      };

      createMasterDataMutation.mutate(payload); // Trigger the mutation
    }
  };

  //handel eCreate Masters
  const handleOpenCreateMasters = () => {
    setOpenCreateMasters(true);
  };

  const handleCloseCreateMasters = () => {
    setFormData({
      name: "",
      category: "",
      inputType: "",
      outOfNorms: "",
      options: [],
    });
    setErrors({
      name: false,
      category: false,
      inputType: false,
      outOfNorms: false,
      options: false,
    });
    setOpenCreateMasters(false);
  };

  //this function for checking the text is being overflow or not
  const [isOverflow, addRef] = CheckOverflow(filteredData);

  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverContent, setPopoverContent] = useState("");

  const handlePopoverOpen = (event, id, content) => {
    if (isOverflow[id]) {
      setAnchorEl(event.currentTarget);
      setPopoverContent(content);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverContent("");
  };

  const open = Boolean(anchorEl);

  if (isSubmittedMasterDataLoading) {
    return (
      <Grid
        container
        item
        md={12}
        xs={12}
        alignContent="flex-start"
        style={{
          paddingLeft: "4%",
          paddingRight: "4%",
          marginTop: "1%",
          paddingBottom: "4%",
        }}
      >
        <Grid
          container
          item
          md={12}
          xs={12}
          alignItems={"center"}
          justifyContent="space-between"
        >
          <Grid item md={6} xs={6}>
            <h3>LIST OF MACHINE SETTING MASTERS</h3>
          </Grid>
        </Grid>
        <Grid item container xs={12} justifyContent="center">
          <h4>Loading...</h4>
        </Grid>
      </Grid>
    );
  }

  if (isSubmittedMasterDataError) {
    return (
      <Grid
        container
        item
        md={12}
        xs={12}
        alignContent="flex-start"
        style={{
          paddingLeft: "4%",
          paddingRight: "4%",
          marginTop: "1%",
          paddingBottom: "4%",
        }}
      >
        <Grid container item md={12} xs={12} justifyContent="space-between">
          <Grid item md={6} xs={6}>
            <h3>LIST OF MACHINE SETTING MASTERS</h3>
          </Grid>
        </Grid>
        <Grid item container xs={12} justifyContent="center">
          <h4 style={{ color: "red" }}>Error Loading Records</h4>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      item
      md={12}
      xs={12}
      alignContent="flex-start"
      style={{
        paddingLeft: "4%",
        paddingRight: "4%",
        marginTop: "1%",
        paddingBottom: "4%",
      }}
    >
      <Grid
        container
        item
        md={12}
        xs={12}
        alignItems={"center"}
        justifyContent="space-between"
      >
        <Grid item container md={5} xs={5}>
          <h3>LIST OF MACHINE SETTING MASTERS</h3>
        </Grid>
        <Grid item md={6.5} xs={6} container justifyContent="space-between">
          <Link to="/saved-parameter-master">
            <Button
              variant="contained"
              className="view-btn"
              style={{
                backgroundColor: "red",
                color: "white",
                textTransform: "none",
              }}
            >
              View Saved Records
            </Button>
          </Link>
          <Button
            variant="contained"
            className="view-btn"
            color="primary"
            style={{
              color: "white",
              textTransform: "none",
            }}
            onClick={() => handleOpenCreateMasters()}
          >
            Create Parameter Masters
          </Button>
          <Link to="/add-parameter-master">
            <Button
              variant="contained"
              className="add-btn"
              color="primary"
              style={{
                // backgroundColor: "#87bfed",
                textTransform: "none",
              }}
            >
              Add Record
            </Button>
          </Link>
        </Grid>
      </Grid>

      <Grid
        container
        item
        xs={12}
        md={12}
        justifyContent="flex-end"
        style={{ marginTop: "3%" }}
      >
        <Grid container item md={4} xs={7}>
          {submittedMasterData?.data?.length > 0 && (
            <TextField
              label="Filter by Party Name / Party Code"
              variant="outlined"
              fullWidth
              value={filterText}
              onChange={handleFilterChange}
              style={{ marginBottom: "20px" }}
            />
          )}
        </Grid>
      </Grid>

      <TableContainer component={Paper} style={{ marginTop: "1%" }}>
        {submittedMasterData?.data?.length === 0 ? (
          <Grid item container xs={12} justifyContent="center">
            <h4>No records found</h4>
          </Grid>
        ) : (
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                <TableCell style={{ width: "80px", fontWeight: "bold" }}>
                  S. NO
                </TableCell>
                <TableCell style={{ maxWidth: "100px", fontWeight: "bold" }}>
                  PARTY NAME
                </TableCell>
                <TableCell style={{ maxWidth: "100px", fontWeight: "bold" }}>
                  PARTY CODE
                </TableCell>
                <TableCell style={{ maxWidth: "100px", fontWeight: "bold" }}>
                  VARIETY
                </TableCell>
                <TableCell
                  style={{ width: actionColumnWidth, fontWeight: "bold" }}
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData?.slice()?.reverse()?.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell style={{ width: "80px" }}>  {filteredData.length - index}</TableCell>
                  <TableCell style={{ maxWidth: "100px" }}>
                    <p
                      className="overflowContain"
                      ref={addRef(`name-${row.id}`)}
                      onMouseEnter={(e) =>
                        handlePopoverOpen(e, `name-${row.id}`, row.partyName)
                      }
                      onMouseLeave={handlePopoverClose}
                    >
                      {row.partyName}
                    </p>
                  </TableCell>
                  <TableCell style={{ maxWidth: "100px" }}>
                    <p
                      className="overflowContain"
                      ref={addRef(`code-${row.id}`)}
                      onMouseEnter={(e) =>
                        handlePopoverOpen(e, `code-${row.id}`, row.partyCode)
                      }
                      onMouseLeave={handlePopoverClose}
                    >
                      {row.partyCode}
                    </p>
                  </TableCell>
                  <TableCell style={{ maxWidth: "100px" }}>
                    <p
                      className="overflowContain"
                      ref={addRef(`variety-${row.id}`)}
                      onMouseEnter={(e) =>
                        handlePopoverOpen(e, `variety-${row.id}`, row.variety)
                      }
                      onMouseLeave={handlePopoverClose}
                    >
                      {row.variety}
                    </p>
                  </TableCell>
                  <TableCell style={{ width: actionColumnWidth }}>
                    <Grid item>
                      <Button
                        variant="contained"
                        className="edit-delete-btn"
                        onClick={() => handleEdit(row.id)}
                        style={{
                          backgroundColor: "rgba(226, 229, 232, 0)",
                          marginRight: "4%",
                        }}
                      >
                        <ModeEditIcon style={{ color: "green" }} />
                      </Button>
                      {/* <Button
                        variant="contained"
                        className="edit-delete-btn"
                        style={{ backgroundColor: "rgba(226, 229, 232, 0)" }}
                        onClick={() => handleOpenDeleteDialog(row.id)}
                      >
                        <DeleteIcon style={{ color: "rgb(167, 27, 34)" }} />
                      </Button> */}
                    </Grid>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      <CreateField
        formData={formData}
        handleChange={handleChange}
        handleCreate={handleCreate}
        createMasterDataMutation={createMasterDataMutation}
        openCreateMasters={openCreateMasters}
        handleCloseCreateMasters={handleCloseCreateMasters}
        errors={errors}
        setFormData={setFormData}
      />

      <Popover
        sx={{ pointerEvents: "none" }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <p style={{ padding: "15px" }}>{popoverContent}</p>
      </Popover>

      <DeleteConfirmationDialog
        open={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        onConfirm={handleDeleteConfirmed}
      />

      <DialogForLoadingMachine open={mutation.isLoading} />
    </Grid>
  );
}

export default ParameterMasters;
